import { emailFlagsFromApi, emailFlagsToApi } from '../Common/emailFlags';

const createUnitModel = (unit = {}) => {
  return {
    id: unit.id || null,
    name: unit.name || '',
    groupId: unit.group?.id || '',
    slug: unit.slug || '',
    hideAnalysisPractice: unit.hide_analysis_practice || false,
    hideAnalysisSimulation: unit.hide_analysis_simulation || false,
    hideReports: unit.hide_reports || false,
    hideCustomTests: unit.hide_custom_tests || false,
    hideStudentCertReport: unit.hide_student_cert_report || false,
    checkSelectUrlPayment: unit.enabled_payment_url_custom || false,
    showOnSignup: unit.show_on_signup || false,
    signUpEmailSaml: unit.sign_up_email_saml || false,
    showOnSlug: unit.show_on_slug || false,
    hasSimulations: unit.has_simulations || false,
    hidePractice: unit.hide_practice || false,
    contentType: unit.content_type?.id || '',
    hideQrCodeCertificate: unit.hide_qr_code_certificate || false,
    hideCategoriesScoreCertificate:
      unit.hide_categories_score_certificate || false,
    scoreControl: unit.score_control || false,
    scoreAvailable: unit.score_available ?? true,
    certificateAvailable: unit.certificate_available ?? true,
    emailSettings: unit.email_settings ?? true,
    ...emailFlagsFromApi(unit),
    language: unit.language || '',
    roundedCefrCertificate: unit.rounded_cefr_certificate || false,
    roundedOverall: unit.rounded_overall || false,
    roundedCategories: unit.rounded_categories || false,
    twoFactorMode: unit.two_factor_mode || 'disabled',
    twoFactorTotpEnabled: unit.two_factor_totp_enabled || false,
    twoFactorEmailEnabled: unit.two_factor_email_enabled || false,
  };
};

const createUnitRequestModel = (unit = {}) => {
  return {
    id: unit.id,
    name: unit.name,
    group_id: unit.groupId,
    slug: unit.slug,
    hide_analysis_practice: unit.hideAnalysisPractice,
    hide_analysis_simulation: unit.hideAnalysisSimulation,
    hide_reports: unit.hideReports,
    hide_custom_tests: unit.hideCustomTests,
    hide_student_cert_report: unit.hideStudentCertReport,
    enabled_payment_url_custom: unit.checkSelectUrlPayment,
    show_on_signup: unit.showOnSignup,
    sign_up_email_saml: unit.signUpEmailSaml,
    show_on_slug: unit.showOnSlug,
    has_simulations: unit.hasSimulations,
    hide_practice: unit.hidePractice,
    content_type_id: unit.contentType,
    hide_qr_code_certificate: unit.hideQrCodeCertificate,
    hide_categories_score_certificate: unit.hideCategoriesScoreCertificate,
    score_control: unit.scoreControl,
    score_available: unit.scoreAvailable,
    certificate_available: unit.certificateAvailable,
    email_settings: unit.emailSettings,
    ...emailFlagsToApi(unit),
    language: unit.language,
    rounded_cefr_certificate: unit.roundedCefrCertificate,
    rounded_overall: unit.roundedOverall,
    rounded_categories: unit.roundedCategories,
    two_factor_mode: unit.twoFactorMode,
    two_factor_totp_enabled: unit.twoFactorTotpEnabled,
    two_factor_email_enabled: unit.twoFactorEmailEnabled,
  };
};

export { createUnitModel, createUnitRequestModel };
